import React from "react";
import { PiPersonArmsSpreadFill } from "react-icons/pi";
import { Link } from "react-router-dom";
import { IoIosAddCircleOutline } from "react-icons/io";
import imageData from "./images";

const PersonaCard = ({ persona, image, linkState }) => (
  <Link
    to="/persona-analyser"
    state={linkState}
    className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-200"
  >
    <div className="bg-[#FC8F41] px-4 py-2">
      <p className="text-sm font-semibold text-white">
        {persona.customer_segment}
      </p>
    </div>
    <div className="p-4 flex items-start gap-4">
      <img
        src={image}
        alt={persona.persona.name}
        className="w-16 h-16 rounded-full object-cover flex-shrink-0"
      />
      <div className="space-y-1 min-w-0">
        <h3 className="text-base font-semibold text-gray-900 truncate text-left">
          {persona.persona.name}
        </h3>
        <div className="space-y-0.5">
          <p className="text-xs text-gray-600 text-left">
            Age: {persona.persona.demographics.age}
          </p>
          <p className="text-xs text-gray-600 truncate text-left">
            {persona.persona.demographics.city}
          </p>
          <p className="text-xs text-gray-600 truncate text-left">
            {persona.persona.demographics.educational_background}
          </p>
        </div>
      </div>
    </div>
  </Link>
);

const AddSegmentCard = () => (
  <button className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center gap-3 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200">
    <IoIosAddCircleOutline className="w-8 h-8 text-gray-400" />
    <p className="text-sm font-semibold text-gray-600">Create New Segment</p>
  </button>
);

const Personas = ({ data }) => {
  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <PiPersonArmsSpreadFill className="w-6 h-6 text-gray-600" />
            <h2 className="text-xl font-bold tracking-tight">
              Customer Segmentation
            </h2>
          </div>
          <Link
            to="/persona-analyser"
            state={{ data }}
            className="px-6 py-2 rounded-lg border-2 border-orng text-orng font-semibold hover:bg-orng hover:text-white transition-colors shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-orng focus:ring-offset-2"
          >
            View More
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="grid grid-cols-2 gap-4">
          {data.map((persona, index) => (
            <PersonaCard
              key={index}
              persona={persona}
              image={imageData[index][0]}
              linkState={{ data }}
            />
          ))}
          <AddSegmentCard />
        </div>
      </div>
    </div>
  );
};

export default Personas;